import { useContext, useMemo } from "react";
import { StringMapContext } from "./StringMapProvider";
export const useStringMap = (componentName, { stringMapDefault, stringMapProp }) => {
    const contextStringMaps = useContext(StringMapContext);
    const stringMapContext = contextStringMaps[componentName];
    return useMemo(() => ({
        ...stringMapDefault,
        ...stringMapContext,
        // TODO warn about passing stringMap as stringMap={{ ... }} without memoization
        ...stringMapProp
    }), [stringMapDefault, stringMapContext, stringMapProp]);
};
